export const copyImageWithFallback = async (blob, fileName = 'capture.png') => {
  if (!blob) {
    throw new Error('Kopyalanacak resim bulunamadi');
  }

  const hasClipboardImageSupport = (
    typeof window !== 'undefined'
    && typeof navigator !== 'undefined'
    && window.isSecureContext
    && typeof window.ClipboardItem !== 'undefined'
    && navigator.clipboard
    && typeof navigator.clipboard.write === 'function'
  );

  if (hasClipboardImageSupport) {
    try {
      await navigator.clipboard.write([
        new window.ClipboardItem({ 'image/png': blob })
      ]);
      return { method: 'clipboard' };
    } catch (error) {
      // Safari gibi ortamlarda write yetkisi/format destegi olmayabilir.
    }
  }

  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

  return { method: 'download' };
};
